import { useState, useEffect } from 'react';
import { BannerWrapper, LoadingSpinner } from '@ecdlink/ui';
import { useHistory } from 'react-router';
import { useOnlineStatus } from '@hooks/useOnlineStatus';
import { useSelector } from 'react-redux';
import { authSelectors } from '@store/auth';
import { userSelectors } from '@store/user';
import { PractitionerService } from '@/services/PractitionerService';

export const Training: React.FC = () => {
  const { isOnline } = useOnlineStatus();
  const history = useHistory();
  const userData = useSelector(userSelectors.getUser);
  const userAuth = useSelector(authSelectors.getAuthUser);
  const [loginUrl, setLoginUrl] = useState<string | null>(null);

  useEffect(() => {
    const fetchLoginUrl = async () => {
      if (userData?.id && userAuth?.auth_token) {
        const data = await new PractitionerService(
          userAuth.auth_token
        ).getMoodleSessionForUserId(userData.id);
        setLoginUrl(data);
      }
    };

    fetchLoginUrl();
  }, [userData?.id, userAuth?.auth_token]);

  return (
    <BannerWrapper
      size="medium"
      renderBorder={true}
      onBack={() => history.goBack()}
      title="Training"
      backgroundColour="white"
      displayOffline={!isOnline}
    >
      {!loginUrl ? (
        <div className="divide-uiLight divide-y-2 divide-dashed">
          <LoadingSpinner
            className="mt-6"
            size={'medium'}
            spinnerColor={'primary'}
            backgroundColor={'uiLight'}
          />
        </div>
      ) : (
        <iframe
          src={loginUrl}
          title="ECD Moodle"
          height="800px"
          width="90%"
          className="divide-uiLight mx-auto divide-y-2 divide-dashed"
        />
      )}
    </BannerWrapper>
  );
};
